import { isBuilder } from "./isBuilder.js";
import { isElementDeclaration } from "./other.js";
export function isKnytDeclaration(value) {
    return isBuilder(value) || isElementDeclaration(value);
}
